/*
 * Copyright (c) Nexign, JSC, 2019-2022.
 */

/**
 *
 *
 * @author Yakov Gushchin
 * @author ILya Babanov
 * @version 1.22.0
 * @since 1.0.1
 */

import { SkeletonButton, SkeletonChart, SkeletonParagraph } from '@components/common';
import { ISkeletonChartProps } from '@components/common/Skeleton/SkeletonChart';
import { ESkeletonKind } from '@components/common/Skeleton/skeletonTypes';

import {
    WidgetSkeletonButtonStyled,
    WidgetSkeletonChartStyled, WidgetSkeletonParagraphNormalStyled,
    WidgetSkeletonParagraphStyled,
} from '../styled/WidgetSkeletonStyled';

export const WidgetSkeletonParagraph = <WidgetSkeletonParagraphStyled>
    <SkeletonParagraph kind={ESkeletonKind.PARAGRAPH_NORMAL}/>
    <SkeletonParagraph kind={ESkeletonKind.PARAGRAPH_SMALL}/>
</WidgetSkeletonParagraphStyled>;

export const WidgetSkeletonParagraphNormal = <WidgetSkeletonParagraphNormalStyled>
    <SkeletonParagraph kind={ESkeletonKind.PARAGRAPH_NORMAL}/>
</WidgetSkeletonParagraphNormalStyled>;

export const WidgetSkeletonButton = <WidgetSkeletonButtonStyled>
    <SkeletonButton kind={ESkeletonKind.BUTTON_ROUND}/>
</WidgetSkeletonButtonStyled>;

export const WidgetSkeletonChart = (props: ISkeletonChartProps) => <WidgetSkeletonChartStyled role='progressbar'>
    <SkeletonChart {...props} />
</WidgetSkeletonChartStyled>;
